const views = {
  common: {
    header: 'header',
    homescreenIncentive: 'homescreen-incentive',
    homescreenNonIncentive: 'homescreen-non-incentive',
    surveyStartScreen: 'survey-start-screen',
    gdpr: 'gdpr',
    footer: 'footer',
  },
  basic: {
    terms: 'terms',
  },
};

export default views;
